var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseIconButton = function SvgCloseIconButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#26262B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.06
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 12.06C12.9817 11.7085 12.4119 11.7085 12.0604 12.06C11.7089 12.4115 11.7089 12.9813 12.0604 13.3328L16.7273 17.9997L12.0604 22.6666C11.7089 23.0181 11.7089 23.5879 12.0604 23.9394C12.4118 24.2909 12.9817 24.2909 13.3331 23.9394L18.0001 19.2725L22.667 23.9394C23.0185 24.2909 23.5883 24.2909 23.9398 23.9394C24.2913 23.5879 24.2913 23.0181 23.9398 22.6666L19.2729 17.9997L23.9398 13.3328C24.2912 12.9813 24.2912 12.4115 23.9397 12.06C23.5883 11.7085 23.0184 11.7085 22.667 12.06L18.0001 16.7269L13.3332 12.06Z",
    fill: "#D3D3DE"
  })));
};
export default SvgCloseIconButton;